import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";

export default function InfoDialog({ open, onClose, title, content }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title || "Informazioni"}</DialogTitle>
            <DialogContent>
                <DialogContentText style={{ whiteSpace: "pre-line" }}>
                    {content || "Contenuto non disponibile al momento. Sarà aggiornato a breve."}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Chiudi</Button>
            </DialogActions>
        </Dialog>
    );
}
